import { Controller } from "stimulus"
import $ from 'jquery'
import 'datatables.net-bs4'

export default class extends Controller {
  static targets = ['pagination', 'entries', 'spinner'];

  initialize() {
    let options = {
      rootMargin: '100px',
    };

    this.intersectionObserver = new IntersectionObserver(entries => this.processIntersectionEntries(entries), options);

    $(this.spinnerTarget).hide();
  }

  connect() {
    // $(this.element).DataTable({
    //   retrieve: true, // Reconnect to existing instance
    //   paging: true, // Enable pagination
    //   searching: true, // Enable searching
    //   order: [[0, "desc"]], // Order by created_at, newest first
    //   pageLength: 25, // Set the number of rows per page
    //   autoWidth: false,
    //   columnDefs: [
    //     { targets: '_all', width: '1%', createdCell: function(td) { td.style.width = '1px'; td.style.whiteSpace = 'nowrap'; td.style.maxWidth = 'max-content'; } }
    //   ]
    // });

    document.querySelectorAll('#pagination').forEach(component => {
      this.intersectionObserver.observe(component)
    });
  }

  disconnect() {
    document.querySelectorAll('#pagination').forEach(component => {
      this.intersectionObserver.unobserve(component)
    });
  }

  processIntersectionEntries(entries) {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        this.loadMore(entry.target);
      }
    });
  }

  loadMore() {
    let next_page = this.paginationTarget.querySelector("a[rel='next']");
    if (next_page == null) return;
    let url = next_page.href;
    $(this.spinnerTarget).show();
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (response) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', response.entries);
        this.paginationTarget.innerHTML = response.pagination;
        // Only check for next page after updating the HTML
        if (!this.paginationTarget.querySelector("a[rel='next']")) {
          this.paginationTarget.style.display = 'none';
        } else {
          this.paginationTarget.style.display = '';
        }
        $(this.spinnerTarget).hide();
      }
    });
  }
}
